module.exports = __webpack_public_path__ + "static/media/lets-go.cac7faf0.gif";